'use strict';

var GetIntrinsic = require('get-intrinsic');

var $Object = GetIntrinsic('%Object%');

var RequireObjectCoercible = require('./RequireObjectCoercible');

// https://262.ecma-international.org/6.0/#sec-toobject

module.exports = function ToObject(value) {
	RequireObjectCoercible(value);
	return $Object(value);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/2022/ToObject.js
 ** module id = 916
 ** module chunks = 0
 **/